// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"50891e1ff1a6820ea273","655":"855e43a8525653f70dce"}[chunkId] + ".js";
};